/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Phase_ExpandingInputs */

const cs_import_progress_phase_expanding = /** @type {(inputs: Import_Progress_Phase_ExpandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozšiřování nabídek`)
};

const en_import_progress_phase_expanding = /** @type {(inputs: Import_Progress_Phase_ExpandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expanding offers`)
};

/**
* | output |
* | --- |
* | "Expanding offers" |
*
* @param {Import_Progress_Phase_ExpandingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_phase_expanding = /** @type {((inputs?: Import_Progress_Phase_ExpandingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Phase_ExpandingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_phase_expanding(inputs)
	return cs_import_progress_phase_expanding(inputs)
});